import React from 'react';
import { Button, Icon, ContentBlock } from '../../pages/DesignSystem';
import './MapFallback.css';

interface MapFallbackProps {
  /** Bascule vers la vue liste existante (toggle déjà géré par le parent, ex: HomePage). */
  onSwitchToList?: () => void;
}

/**
 * UI affichée à la place de la carte quand MapLibre ne peut pas s'afficher
 * (WebGL indisponible ou crash à l'init). Rendue à la fois par la détection
 * préventive dans MapLibreView et par MapErrorBoundary.
 *
 * Ton volontairement rassurant ("Carte indisponible", pas "Erreur") :
 * le reste de l'app fonctionne, seule la carte est concernée.
 */
const MapFallback: React.FC<MapFallbackProps> = ({ onSwitchToList }) => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="map-fallback">
      <ContentBlock
        variant="light"
        padding="lg"
        size="sm"
        centered
        className="map-fallback__card"
      >
        <div className="map-fallback__body">
          <Icon name="MapPinOff" size={40} className="map-fallback__icon" />
          <h3 className="map-fallback__title">Carte indisponible</h3>
          <p className="map-fallback__message">
            Votre navigateur ne peut pas afficher la carte pour le moment.
            Vous pouvez continuer à explorer les événements dans la liste.
          </p>
          <div className="map-fallback__actions">
            {onSwitchToList && (
              <Button
                variant="primary"
                size="md"
                className="map-fallback__cta map-fallback__cta--primary"
                onClick={onSwitchToList}
              >
                <Icon name="List" size={18} />
                <span>Voir la liste</span>
              </Button>
            )}
            <Button
              variant="outline"
              size="md"
              className="map-fallback__cta map-fallback__cta--secondary"
              onClick={handleReload}
            >
              <Icon name="RefreshCw" size={18} />
              <span>Recharger la page</span>
            </Button>
          </div>
        </div>
      </ContentBlock>
    </div>
  );
};

export default MapFallback;
